import BaseAction from "../base-action";
import {ActionTypeEnum} from "../../base/training-literals";

class SceneTransformation extends BaseAction {
    position;
    quaternion;
    scale;

    constructor(props = {}) {
        super(props);
        this.actionType = ActionTypeEnum.SCENE_TRANSFORMATION;
        this.position = props.position || [0, 1.6, 0];
        this.quaternion = props.quaternion || [0, 0, 0, 1];
        this.scale = props.scale || [1, 1, 1];
    }

    get(props = {}) {
        return {
            type: this.actionType,
            position: props.position || this.position,
            quaternion: props.quaternion || this.quaternion,
            scale: props.scale || this.scale,
            duration: props.duration || this.duration,
        }
    }
}

export default SceneTransformation;